// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.viewer[data-v-f7b1e8a2] {\n  width: 100%;\n  height: 90%;\n  padding-top: 12px;\n}\n.viewer[data-v-f7b1e8a2]:first-child {\n  position: sticky !important;\n}\n", ""]);
// Exports
module.exports = exports;
